import lang from '@/langs'
export const materialStatus = (type: number) => {
  if (type === 1) {
    return {
      name: lang('处理中'),
      boxStyle: {
        background: 'rgba(245, 125, 88, 0.1)',
        color: 'rgba(245, 125, 88, 1)'
      }
    }
  } else if (type === 6) {
    return {
      name: lang('已确认'),
      boxStyle: {
        background: 'rgba(57, 174, 133, 0.1)',
        color: 'rgba(57, 174, 133, 1)'
      }
    }
  } else if (type === 2) {
    return {
      name: lang('已取消'),
      boxStyle: {
        background: 'rgba(246, 246, 246, 1)',
        color: 'rgba(153, 153, 153, 1)'
      }
    }
  } else if (type === 4) {
    return {
      name: lang('已驳回'),
      boxStyle: {
        background: 'rgba(246, 246, 246, 1)',
        color: 'rgba(153, 153, 153, 1)'
      }
    }
  } else if (type === 5) {
    return {
      name: lang('待确认'),
      boxStyle: {
        background: 'rgba(245, 125, 88, 0.1)',
        color: 'rgba(245, 125, 88, 1)'
      }
    }
  } else {
    return {
      name: lang('处理中'),
      boxStyle: {
        background: 'rgba(245, 125, 88, 0.1)',
        color: 'rgba(245, 125, 88, 1)'
      }
    }
  }
}
